import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import { PostCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCroquisSketch/postCroquisSketchQuery.type';

export const postCroquisSketchFunction = (
  params: PostCroquisSketchQueryParamsType,
): Promise<{}> => {
  const data = new FormData();
  const image = ConvertUrlToFile(params?.data?.image, 'image', 'image');
  data.append('image', image);
  data.append('title', params.data.title);
  return fetchApi({
    method: 'post',
    url: `property/reports/${params.id}/accident_users/culprit/images/croquis_image/`,
    data,
  });
};
